import { Link as LinkR } from 'react-router-dom';
import styled from 'styled-components';

export const DiscussionContainer = styled.div`
  background: #f5f5f5;
  color: #000;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  padding: 100px 10px 10px 75px;
  height: flex;
  position: relative;
`;


export const RowOneContainer = styled.div`
  display: flex;
  flex-direction: row;
  grid-gap: 20px;
  justify-content: center;
  align-items: center;;
`;


export const RowTwoContainer = styled.div`
  display: grid;
  flex-direction: row;
  margin-top: 20px;
  grid-template-columns: 400px 400px 400px;
  grid-gap: 20px;
  justify-content: center;
  align-items: center;;
`;

export const Card = styled.div`
  background-color: #f5f5f5;
  border-style: solid;
  border-color: #f5f5f5;
  border-radius: 15px;
  box-shadow:-1px 1px 5px 2px rgba(0, 0, 0, 0.7);
  color: white;
`;


export const TextWrapper = styled.div`
  padding-top: 0;
  padding-bottom: 10px;
  text-align: center;
`;

export const TopLine = styled.div`
  margin-top: 24px;
  width: 400px;
  color: #006ee6;
  font-size: 20px;
  font-weight: 700;
  letter-spacing: 1.4px;
  text-transform: uppercase;
  margin-bottom: 16px;
`;

export const SectionText = styled.p`
  max-width: 440px;
  padding: 35px;
  font-size: 16px;
  line-height: 24px;
  color: #006ee6;
`;


export const BtnWrap = styled.div`
  display: flex;
  justify-content: center;
`;

export const BtnLink = styled(LinkR)`
  border-radius: 50px;
  background: #006ee6;
  white-space: nowrap;
  padding: 10px 22px;
  color: #006ee6;
  font-size: 16px;
  outline: none;
  border: none;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  text-decoration: none;

  &:hover {
    transition: all 0.2s ease-in-out;
    background: #fff;
    color: #006ee6;
  }
`;